import { CredentialField } from "../shared/CredentialField";

export const PostHogCredentialsForm = ({
  credentials,
  onCredentialsChange,
}) => {
  const handleChange = (field) => (value) =>
    onCredentialsChange({ ...credentials, [field]: value });

  return (
    <div className="px-6 pb-4">
      <h3 className="mb-1 text-sm font-semibold text-gray-900">
        Connection Details
      </h3>
      <p className="mb-4 text-xs text-gray-500">
        Enter your PostHog credentials to connect.
      </p>

      <div className="space-y-4">
        <CredentialField
          label="Personal API Key"
          value={credentials.api_key}
          onChange={handleChange("api_key")}
          type="password"
          placeholder="phx_..."
          tooltip="Found in PostHog Settings Personal API Keys. Must have read access to events."
        />
        <CredentialField
          label="Project ID"
          value={credentials.project_id}
          onChange={handleChange("project_id")}
          placeholder="12345"
          tooltip="Found in PostHog Project Settings. The numeric project identifier."
        />
      </div>
    </div>
  );
};
